import { Observable } from 'rxjs';
import { IAmrFilterValues, IAzureFiltersSearchApi, ICtFilterValues } from '@vivli/features/search/infrastructure/interface';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';
import { useAzureSearch } from './use-azure-search.hook';
import { IAzureSearchApiOptions } from '@vivli/core/infrastructure/interface';

export const useAzureFiltersSearch = (options: IAzureSearchApiOptions): IAzureFiltersSearchApi => {
    const azureSearch = useAzureSearch(options);

    const amrFacets = [
        'antimicrobials,count:200,sort:value',
        'groupingsOfResistancePatterns,count:50,sort:value',
        'organisms,count:1500,sort:value',
        'specimenSources,count:200,sort:value',
        'sampleTimes',
        'countries,count:300,sort:value',
        'regions',
        'yearsDataCollected,count:50',
        'sponsorName,count:500,sort:value',
    ];

    const ctFacets = [
        'studyDesign',
        'locationsOfStudySites,count:300,sort:value',
        'sponsorType',
        'contributorType',
        'sponsorName,count:500,sort:value',
        'studyType',
        'actualEnrollment,interval:100',
        'funder,count:500',
        'orgName,count:500',
    ];

    const getFilterValues = <T>(facets: string[], assignedAppType: AssignedAppTypeEnum = AssignedAppTypeEnum.Default): Observable<T> => {
        return azureSearch.getFacets<T>({
            facets,
            filter: `assignedAppType eq '${assignedAppType}'`,
        });
    };

    const getAmrFilterValues = (): Observable<IAmrFilterValues> => {
        return getFilterValues<IAmrFilterValues>(amrFacets, AssignedAppTypeEnum.Amr);
    };

    const getCtFilterValues = (): Observable<ICtFilterValues> => {
        return getFilterValues<ICtFilterValues>(ctFacets);
    };

    return {
        amrFacets,
        ctFacets,
        getFilterValues,
        getAmrFilterValues,
        getCtFilterValues,
    };
};
